module.exports = __webpack_public_path__ + "static/media/rollet_vert_slid.f982d9df.png";